import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';

export interface PublicConfig {
  success: boolean;
  allowPublicRegistration: boolean;
}

@Injectable({ providedIn: 'root' })
export class PublicConfigService {
  private http = inject(HttpClient);
  private loaded = false;
  private allowPublicRegistrationValue = false;

  /** Loads once; safe to call multiple times. */
  async load(): Promise<void> {
    if (this.loaded) {
      return;
    }
    const url = `${environment.apiBaseUrl}/v1/public/config`;
    try {
      const data = await firstValueFrom(this.http.get<PublicConfig>(url));
      this.allowPublicRegistrationValue = data.allowPublicRegistration === true;
    } catch {
      this.allowPublicRegistrationValue = environment.allowPublicRegistrationFallback === true;
    }
    this.loaded = true;
  }

  allowPublicRegistration(): boolean {
    return this.allowPublicRegistrationValue;
  }
}
